export const LOAD_CURRENT_USER = "LOAD_CURRENT_USER";